export const Pricing = () => { 
    return (
            <div className='main about'>

                <div className='aside'><div></div></div>

                <div className='content has-aside static'>
                    <div className='intro'>
                        <h1>Pricing</h1>
                        <p>Information about Premium will go here.</p>
                    </div>
                    <div className='features'>
                        <h2>Features</h2>
                        <ul>
                            <li><strong>Stealth Mode</strong>
                            <p>With one click, hide all images and videos from displaying.</p></li>
                            <li><strong>Desktop and Mobile</strong>
                            <p>Browser based for additional security.</p></li>
                            <li><strong>By the Community, For the Community.</strong>
                            <p>Created by an LGBTQ+ team, Flintt recognises the need for safety and discretion.</p></li>
                        </ul>
                    </div>                           
                </div> 
            </div>
    )
}